<template>
  <div class="container">
    <img src="@/assets/logo_blue.png" class="logo" />
    <Form class="form" @submit="onBeforeSubmit" :validation-schema="validationSchema" :initial-values="formValues">
      <FormError :errors="globalErrors" />
      <div class="form-header">
        <span class="uk-text-bold uk-text-large">パスワードリセット</span>
      </div>
      <div class="field">
        <Field name="username" v-slot="{ field }">
          <FieldLabel title="ユーザーID" :required="true" />
          <input class="uk-input" type="text" v-bind="field" />
        </Field>
        <FieldError name="username" />
      </div>
      <div class="field">
        <Field name="confirmationCode" v-slot="{ field }">
          <FieldLabel title="認証コード" :required="true" />
          <input class="uk-input" type="text" v-bind="field" />
        </Field>
        <FieldError name="confirmationCode" />
      </div>
      <div class="field">
        <Field name="password" v-slot="{ field }">
          <FieldLabel title="パスワード" :required="true" />
          <input
            class="uk-input"
            :type="inputLock ? 'password' : 'text'"
            v-bind="field"
            placeholder="英字（大文字・小文字）、記号、数字を含む"
            autocomplete="new-password"
          />
          <span class="input-icon" :uk-icon="inputLock ? 'icon: lock' : 'icon: unlock'" @click="inputLock = !inputLock"></span>
        </Field>
        <FieldError name="password" />
      </div>
      <div class="submit-button">
        <button type="button" class="uk-button" @click="onGoLogin">
          ログイン画面へ
        </button>
        <ActionButton title="リセット" color="primary" type="submit" :disabled="processing" />
      </div>
    </Form>
  </div>
</template>
<style lang="scss" scoped>
@include modal-form;
.container {
  display: flex;
  height: 100vh !important;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  background-color: #fff;
}
.form {
  width: 400px;
  form {
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
  }
}
.submit-button {
  display: flex;
  justify-content: space-between;
}
.form-header {
  margin-bottom: $spacing-medium;
  margin-top: $spacing-ex-small;
}
.uk-button {
  text-transform: none;
  width: 185px;
  color: #fff;
  background-color: $brand-color;
}
.input-icon {
  cursor: pointer;
  position: relative;
  float: right;
  top: -30px;
  right: 10px;
}
</style>
<script lang="ts">
import { Options } from "vue-class-component";
import { Prop } from "vue-property-decorator";
import { Field, Form } from "vee-validate";
import * as yup from "yup";
import { AuthApi } from "../../autogen";
import FieldError from "../atoms/FieldError.vue";
import FormError from "../atoms/FormError.vue";
import FieldLabel from "../atoms/FieldLabel.vue";
import ChangePassword from "../organisms/ChangePassword.vue";
import FormMixin from "../../helpers/mixins/form";
import ActionButton from "@/components/atoms/ActionButton.vue";
type FormValues = {
  username: string;
  confirmationCode: string;
  password: string;
};
@Options({
  components: { Form, Field, FieldError, FormError, ChangePassword, FieldLabel, ActionButton }
})
export default class ResetPassword extends FormMixin {
  globalErrors: { message: string }[] = [];
  @Prop({ type: String }) usernamea!: string;
  formValues: FormValues = {
    username: this.usernamea,
    confirmationCode: "",
    password: ""
  };
  inputLock = true;
  async onBeforeSubmit(values: FormValues) {
    await this.onSubmit(async () => {
      await new AuthApi().confirmForgotPassword({
        confirmForgotPasswordRequest: values
      });
      this.$router.push("/login");
    });
  }
  validationSchema!: yup.AnyObjectSchema;
  beforeCreate() {
    this.validationSchema = yup.object({
      username: yup.string().required(this.$t("input_required", { field: "ユーザーID" })),
      confirmationCode: yup.string().required(this.$t("input_required", { field: "認証コード" })),
      password: yup.string().required(this.$t("input_required", { field: "パスワード" }))
    });
  }
  onGoLogin() {
    this.$router.push("/login");
  }
}
</script>
